import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import $7GIZw$react from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $70d70eb16ea48428$var$Row(props) {
  return null;
}

$70d70eb16ea48428$var$Row.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props, context) {
  var children, textValue, UNSTABLE_childItems;
  return _regeneratorRuntime.wrap(function getCollectionNode$(_context2) {
    while (1) switch (_context2.prev = _context2.next) {
      case 0:
        children = props.children, textValue = props.textValue, UNSTABLE_childItems = props.UNSTABLE_childItems;
        _context2.next = 3;
        return {
          type: 'item',
          props: props,
          textValue: textValue,
          'aria-label': props['aria-label'],
          hasChildNodes: true,
          childNodes: /*#__PURE__*/_regeneratorRuntime.mark(function childNodes() {
            var _iterator, _step, column, _iterator2, _step2, child, cells, childRows, columnCount;

            return _regeneratorRuntime.wrap(function childNodes$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  if (!context.showDragButtons) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return {
                    type: 'cell',
                    key: 'header-drag',
                    props: {
                      isDragButtonCell: true
                    }
                  };

                case 3:
                  if (!(context.showSelectionCheckboxes && context.selectionMode !== 'none')) {
                    _context.next = 6;
                    break;
                  }

                  _context.next = 6;
                  return {
                    type: 'cell',
                    key: 'header',
                    props: {
                      isSelectionCell: true
                    }
                  };

                case 6:
                  if (!(typeof children === 'function')) {
                    _context.next = 44;
                    break;
                  }

                  _iterator = _createForOfIteratorHelper(context.columns);
                  _context.prev = 8;

                  _iterator.s();

                case 10:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 16;
                    break;
                  }

                  column = _step.value;
                  _context.next = 14;
                  return {
                    type: 'cell',
                    element: children(column.key),
                    key: column.key // this is combined with the row key by CollectionBuilder

                  };

                case 14:
                  _context.next = 10;
                  break;

                case 16:
                  _context.next = 21;
                  break;

                case 18:
                  _context.prev = 18;
                  _context.t0 = _context["catch"](8);

                  _iterator.e(_context.t0);

                case 21:
                  _context.prev = 21;

                  _iterator.f();

                  return _context.finish(21);

                case 24:
                  if (!UNSTABLE_childItems) {
                    _context.next = 42;
                    break;
                  }

                  _iterator2 = _createForOfIteratorHelper(UNSTABLE_childItems);
                  _context.prev = 26;

                  _iterator2.s();

                case 28:
                  if ((_step2 = _iterator2.n()).done) {
                    _context.next = 34;
                    break;
                  }

                  child = _step2.value;
                  _context.next = 32;
                  return {
                    type: 'item',
                    value: child
                  };

                case 32:
                  _context.next = 28;
                  break;

                case 34:
                  _context.next = 39;
                  break;

                case 36:
                  _context.prev = 36;
                  _context.t1 = _context["catch"](26);

                  _iterator2.e(_context.t1);

                case 39:
                  _context.prev = 39;

                  _iterator2.f();

                  return _context.finish(39);

                case 42:
                  _context.next = 52;
                  break;

                case 44:
                  cells = [];
                  childRows = [];
                  columnCount = 0;
                  (0, $7GIZw$react).Children.forEach(children, function (node) {
                    if (node.type === $70d70eb16ea48428$var$Row) {
                      if (cells.length < context.columns.length) throw new Error('All of a Row\'s child Cells must be positioned before any child Rows.');
                      childRows.push({
                        type: 'item',
                        element: node
                      });
                    } else {
                      cells.push({
                        type: 'cell',
                        element: node
                      });

                      var _node_props_colSpan;

                      columnCount += (_node_props_colSpan = node.props.colSpan) !== null && _node_props_colSpan !== void 0 ? _node_props_colSpan : 1;
                    }
                  });

                  if (!(columnCount !== context.columns.length)) {
                    _context.next = 50;
                    break;
                  }

                  throw new Error("Cell count must match column count. Found ".concat(columnCount, " cells and ").concat(context.columns.length, " columns."));

                case 50:
                  return _context.delegateYield(cells, "t2", 51);

                case 51:
                  return _context.delegateYield(childRows, "t3", 52);

                case 52:
                case "end":
                  return _context.stop();
              }
            }, childNodes, null, [[8, 18, 21, 24], [26, 36, 39, 42]]);
          }),
          shouldInvalidate: function shouldInvalidate(newContext) {
            // Invalidate all rows if the columns changed.
            return newContext.columns.length !== context.columns.length || newContext.columns.some(function (c, i) {
              return c.key !== context.columns[i].key;
            }) || newContext.showSelectionCheckboxes !== context.showSelectionCheckboxes || newContext.showDragButtons !== context.showDragButtons || newContext.selectionMode !== context.selectionMode;
          }
        };

      case 3:
      case "end":
        return _context2.stop();
    }
  }, getCollectionNode);
});
/**
 * A Row represents a single item in a Table and contains Cell elements for each column.
 * Cells can be statically defined as children, or generated dynamically using a function
 * based on the columns defined in the TableHeader.
 */
// We don't want getCollectionNode to show up in the type definition

var $70d70eb16ea48428$export$b59bdbef9ce70de2 = $70d70eb16ea48428$var$Row;
export { $70d70eb16ea48428$export$b59bdbef9ce70de2 as Row };